import Validator from 'validatorjs';
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IQuoteQuestion } from '../../classes/ExternalQuote';

Validator.registerImplicit('wrong_answer', function (this: any, value, requirement, attribute) {
    const question = this.validator.input as IQuoteQuestion;

    if (!question.anyAnswer && question.answer !== question.defaultValue) {
        return false;
    }
    return true;
});

interface LooseObject {
    [key: string]: any
}


export const allFieldsValidation = (data) => {
    const specialCodes = ["1", "2", "4", "5", "6", "7", "9"];

    var customErrorMessages = {
        "wrong_answer": specialCodes.includes(data.code)
            ? "We can’t finish online with this answer, but we may still be able to help! Call or text us at 918-744-5145 to review your options and get a policy started"
            : "Sorry we can't continue with this answer to the question"
    };

    var rules: LooseObject = {};
    rules["answer_" + data.code] = ['required', 'wrong_answer'];

    var _data: LooseObject = {};
    _data["answer_" + data.code] = data.answer;
    _data.answer = data.answer;
    _data.anyAnswer = data.anyAnswer;
    _data.defaultValue = data.defaultValue;
    return allFieldsValidationCommon(_data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};